import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import fetchLastVehicles from '../../../services/vehicles/last-entries';
import { getLastVehiclesKey } from '../query-keys';

const getLastVehicles = (
  options: {
    locale: string;
    part?: string;
    vehicle?: string;
    category?: string;
    page?: 'home' | 'catalogue' | 'brands';
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchLastVehicles>
] => [
  getLastVehiclesKey(options),
  ({
    queryKey: [, locale, part, vehicle, category, page],
  }: QueryFunctionContext<string[], any>): Promise<any> =>
    fetchLastVehicles({
        locale,
        ...(part && { partIdentifier: part }),
        ...(vehicle && { carIdentifier: vehicle }),
        ...(category && { categoryIdentifier: category }),
        ...(page && { pageIdentifier: page }),
      },
      req
    ),
];

export default getLastVehicles;
